import React from 'react';

import { SvgIcon } from '@infoods/lifebase-ui';

import { ReactComponent as SwymoLogoIcon } from '../../../../../../../shared/assets/icons/swymo-logo-icon.svg';
import {
  GridTableCell,
  GridTableRow,
  UserInfoCell,
  EditDeleteButtonGroup,
} from '../../../../../../../shared/components/table-components';
import { ParticipantRowInfo } from '../../../../../../interfaces/participants-list/ParticipantRowInfo';
import {
  dateFormat,
  localDataFormat,
} from '../../../../../../../shared/constants/apiDateFormat';
import { getFormattedDate } from '../../../../../../../shared/utils/dateUtils';

type ParticipantRowProps = {
  participant: ParticipantRowInfo;
  onEdit: (participant: ParticipantRowInfo) => void;
  onDelete: (id: number) => void;
};

const ParticipantRow = ({ participant, onEdit, onDelete }: ParticipantRowProps) => {
  const {
    id,
    firstName,
    lastName,
    email,
    phone,
    nickname,
    division,
    initialScanDate,
    lastScanDate,
    lifeBaseUser,
  } = participant;

  const formatDate = (date: string | null) =>
    date ? getFormattedDate(date, localDataFormat, dateFormat) : '—';

  return (
    <GridTableRow variant="row" dataTestId="participant-row">
      <GridTableCell dataTestId="name-cell">
        <UserInfoCell
          firstName={firstName}
          lastName={lastName}
          email={email}
          phone={phone}
          nameAdornment={
            lifeBaseUser && (
              <SvgIcon component={SwymoLogoIcon} inheritViewBox fontSize="small" />
            )
          }
          href=""
          disabled
        />
      </GridTableCell>
      <GridTableCell dataTestId="leaderboard-name-cell">{nickname || '—'}</GridTableCell>
      <GridTableCell dataTestId="division-cell">{division?.name || '—'}</GridTableCell>
      <GridTableCell dataTestId="initial-scan-date-cell">
        {formatDate(initialScanDate)}
      </GridTableCell>
      <GridTableCell dataTestId="last-scan-date-cell">
        {formatDate(lastScanDate)}
      </GridTableCell>
      <EditDeleteButtonGroup
        onEdit={() => onEdit(participant)}
        onDelete={() => onDelete(id)}
        modalTitle={`Are you sure you want to remove ${firstName} ${lastName} from the challenge?`}
        confirmBtnText="Confirm"
        size="medium"
      />
    </GridTableRow>
  );
};

export { ParticipantRow };
